import { publicRuntimeConfig } from '../_cactus_core/config/runtime';

export const useTitleFromBackoffice = true;

let appName = '';

try {
  appName = process.env.APP_NAME || publicRuntimeConfig().appName || '';
} catch (error) {
  appName = process.env.APP_NAME || '';
}

export const metaTitle = `${appName} 🍀 Cassino e Apostas Online | Apostas Esportivas`;

export const useDescriptionFromBackoffice = true;

export const metaDescription = `${appName} — apostas esportivas e jogos online autorizados. Plataforma segura com saque rápido. 18+ | Jogue com responsabilidade.`;
